"use client"

import type { ComponentProps, FunctionComponent } from "react"

import { clsx } from "clsx"

import { useLayoutContext } from "@/modules/landingSearch/components/Layout/LayoutContextProvider"
import { Pagination as SparkPagination } from "@/modules/layouts/components/Pagination/Pagination"

import styles from "./Pagination.module.css"

type PaginationProps = ComponentProps<typeof SparkPagination>

export const Pagination: FunctionComponent<PaginationProps> = ({ className, ...props }) => {
  const { isSearchLoading, updateSearchLoadingStatus } = useLayoutContext()

  return (
    <SparkPagination
      {...props}
      className={clsx(className, isSearchLoading && styles["main--loading"])}
      onPaginate={() => {
        updateSearchLoadingStatus(true)
      }}
    />
  )
}
